import { render, staticRenderFns } from "./ListWarrantyReception.vue?vue&type=template&id=80ff3ce6&scoped=true"
import script from "./ListWarrantyReception.vue?vue&type=script&lang=js"
export * from "./ListWarrantyReception.vue?vue&type=script&lang=js"
import style0 from "./ListWarrantyReception.vue?vue&type=style&index=0&id=80ff3ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ff3ce6",
  null
  
)

export default component.exports